module.exports = __webpack_public_path__ + "7ad8883ba29dec89e7f23226bb4a4d56.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-23.png
// module id = 1759
// module chunks = 0